class FloatWithTwoDecimals {
    public value: number;

    constructor(value: number) {
       this.value = parseFloat(value.toFixed(2));
    }
}

//removeIf(production)
export default FloatWithTwoDecimals;
//endRemoveIf(production)